/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { RmsLoggedUserDto, useQueryGetRefreshAndRetrieveUserConfiguration } from '../../backend';
import { useOidc } from './OidcContext';

export const useRenewToken = () => {
    const oidcState = useOidc();
    if (!oidcState.isUserLoggedIn) {
        return () => Promise.resolve();
    }
    return oidcState.renewTokens;
};

export const useGetUserData = (): RmsLoggedUserDto | undefined =>
    useQueryGetRefreshAndRetrieveUserConfiguration({ staleTime: Infinity }).data;

/**
 * selector hooks
 */
export const useCurrentUser = () => useGetUserData();
export const useCurrentUserClient = () => useGetUserData()?.client;
export const useCurrentUserClientTimezone = () => useGetUserData()?.client?.timeZoneId || 'Europe/Paris';
export const useCurrentUserSettingsLanguage = () => useGetUserData()?.settings?.language;
